import WIDGETS from './widgets.js';

export default {
  name: 'ticket_video_conference',
	spacing: 0,
	widgets: [
		{
			content: WIDGETS.TICKET_VIDEO_CONFERENCE,
			breakpoints: { xs: 12 },
			lazy_loading: 0,
		},
	],
};
